import { Component } from '@angular/core'

@Component({
  selector: 'app-notion-divider-component',
  standalone: true,
  imports: [],
  templateUrl: './notion-divider-component.html',
  styleUrl: './notion-divider-component.sass',
})
export class NotionDividerComponent {}
